import styled from 'styled-components';
import { Container, Card } from 'react-bootstrap';

export const CommentStyles = styled(Container)`
  height: 500px;
  .comments {
    max-height: 100%;
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    overflow: scroll;
    ::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 7px;
      height: 4px;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: #007bff;
      box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
    }
  }
  .form-inline {
    width: 100%;
    .form-control {
      width: 85%;
      border-radius: 0.25rem 0 0 0.25rem;
    }
    button {
      width: 15%;
      border-radius: 0 0.25rem 0.25rem 0;
    }
  }

  .no-comment {
    height: 500px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }
`;

export const CardStyle = styled(Card)`
  margin: 10px 0;
  @media (min-width: 426px) {
    width: 35%;
    align-self: ${(props) => props.user || 'flex-start'};
  }
`;
